import CurrencyIcon from '../ui/icons/currency-icon';

const InstallmentText = ({ locale, mainPrice, onClick, payNum = 4 }) => {
  return (
    <span className='ms-3 text-sm font-medium md:text-[15px]'>
      <span className=''>
        <span>
          {' '}
          {locale === 'ar' ? 'قسمها على' : 'Divide it into'} {payNum}{' '}
          {locale === 'ar' ? 'دفعات' : 'installments of'} {mainPrice}
        </span>
        <CurrencyIcon className='mx-0.5 inline size-3' />
        <span className=''>
          {locale === 'ar'
            ? 'تقسيط بدون فوائد. متوافق مع الشريعة'
            : ' interest-free , Sharia-compliant'}
        </span>
        <span
          className='ms-3 cursor-pointer text-[12px] whitespace-nowrap underline'
          onClick={onClick}
        >
          {locale === 'en' ? 'Learn more' : 'اكتشف المزيد'}
        </span>
      </span>
    </span>
  );
};

export default InstallmentText;
